import { render } from "./OurCoreServiceTintas.vue?vue&type=template&id=3a31bc29&scoped=true"
import script from "./OurCoreServiceTintas.vue?vue&type=script&lang=js"
export * from "./OurCoreServiceTintas.vue?vue&type=script&lang=js"

import "./OurCoreServiceTintas.vue?vue&type=style&index=0&id=3a31bc29&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a31bc29"]])

export default __exports__